module.exports = __webpack_public_path__ + "static/P2101487-b563ba50644b8f602cdc02f30e75ead3.jpg";